export const DRAWER_ANIMATION_DURATION = 400
